import "src/javascripts/jobs_new/index.js"
